module.exports = __webpack_public_path__ + "media/images/pages/peel/table-df9a61e300a0e7290526e580a3dea947.png";